import { render, staticRenderFns } from "./free.vue?vue&type=template&id=471e1a9c&"
import script from "./free.vue?vue&type=script&lang=js&"
export * from "./free.vue?vue&type=script&lang=js&"
import style0 from "./free.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports